export default __webpack_public_path__ + "static/media/entypo_gauge.fa09a943.svg";